import { openDB } from "idb";

class LocationDB {
  constructor() {
    this.dbPromise = this.initDB();
  }

  async initDB() {
    return openDB("depanneurs", 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains("locations")) {
          db.createObjectStore("locations", { keyPath: "id" });
        }
      },
    });
  }

  async getData(id) {
    try {
      const db = await this.dbPromise;
      const tx = db.transaction("locations", "readonly");
      const store = tx.objectStore("locations");
      return await store.get(id);
    } catch (error) {
      console.log("Error occurred: ", error.message);
    }
  }

  async setData(id, data) {
    try {
      const db = await this.dbPromise;
      const tx = db.transaction("locations", "readwrite");
      const store = tx.objectStore("locations");
      await store.put({ id, data });
      await tx.done;
    } catch (error) {
      console.log("Error occurred: ", error.message);
    }
  }
}
const locationDB = new LocationDB();
export default locationDB;
